import { gql } from "@apollo/client";

export const GET_AUTORIZACION_PRECIOS_ESTADOS = gql`
query GetAutorizacionPreciosEstados {
  autorizacionPreciosEstados {
    success
    error
    valorEsperado {
      idAutorizacionControlEstado
      descripcion
    }
  }
}`;


const adaptEstadoRow = (estado) => {
  return {
    id: estado?.idAutorizacionControlEstado,
    displayName: estado?.descripcion
  };
};

export const adaptEstadosArray = (estados) => {
  if (!estados?.autorizacionPreciosEstados?.success) return [];
  return (
    structuredClone(
      estados?.autorizacionPreciosEstados?.valorEsperado
    )?.map((estado) => adaptEstadoRow(estado)) || []);

};